module.exports = __webpack_public_path__ + "img/logo-light.0d7d01a7.svg";